import { isMaybeOpenToWork, parseBoolean } from './boolean';

export const hasScrapedTime = (candidate) => {
  const value = candidate?.scraped_time;
  return value != null && String(value).trim() !== '';
};

export const getCandidateCareerStatus = (candidate) => {
  if (!hasScrapedTime(candidate)) return 'Pending';
  if (parseBoolean(candidate.is_open_to_work)) return 'Open to Work';
  if (isMaybeOpenToWork(candidate.is_open_to_work)) return 'Potential Open to Work';
  return 'Not Open to Work';
};

export const getCandidateListStatus = (candidate) => {
  if (!hasScrapedTime(candidate)) return 'pending';
  if (parseBoolean(candidate.invalid_link)) return 'unavailable';
  if (parseBoolean(candidate.is_open_to_work)) return 'active-seeker';
  if (isMaybeOpenToWork(candidate.is_open_to_work)) return 'potential-seeker';
  return 'stable';
};

export const matchesStatusFilter = (candidate, statusFilter) => {
  if (statusFilter === 'manual') return parseBoolean(candidate.is_open_to_work_manual);
  if (statusFilter === 'pending') return !hasScrapedTime(candidate);
  if (statusFilter === 'unavailable') {
    return hasScrapedTime(candidate) && parseBoolean(candidate.invalid_link);
  }
  if (statusFilter === 'active-seeker') {
    return hasScrapedTime(candidate)
      && !parseBoolean(candidate.invalid_link)
      && parseBoolean(candidate.is_open_to_work);
  }
  if (statusFilter === 'potential-seeker') {
    return hasScrapedTime(candidate)
      && !parseBoolean(candidate.invalid_link)
      && isMaybeOpenToWork(candidate.is_open_to_work);
  }
  if (statusFilter === 'stable') {
    return hasScrapedTime(candidate)
      && !parseBoolean(candidate.invalid_link)
      && !parseBoolean(candidate.is_open_to_work)
      && !isMaybeOpenToWork(candidate.is_open_to_work);
  }
  return true;
};

export const hasCandidatePhone = (candidate) =>
  Boolean(String(candidate?.phone ?? '').trim());

export const isLinkedinBlocked = (candidate) =>
  parseBoolean(candidate?.invalid_link);

export const matchesContactFilter = (candidate, contactFilter) => {
  if (!contactFilter || contactFilter === 'all') return true;
  if (contactFilter === 'linkedin-blocked') return isLinkedinBlocked(candidate);
  if (contactFilter === 'phone-missing') return !hasCandidatePhone(candidate);
  if (contactFilter === 'phone-available') return hasCandidatePhone(candidate);
  if (contactFilter === 'linkedin-available') return !isLinkedinBlocked(candidate);
  return true;
};
